
// services/vendorService.js
const API_BASE = "https://server.havbit.in/api";

export const vendorService = {
  // Get vendor by ID
  async getVendorById(vendorId) {
    try {
      const response = await fetch(`${API_BASE}/vendors/${vendorId}`);
      if (!response.ok) {
        // Try to get from products API
        const productsResponse = await fetch(`${API_BASE}/products`);
        if (!productsResponse.ok) throw new Error("Vendor not found");
        
        const data = await productsResponse.json();
        const products = data.data || data.products || [];
        
        // Find a product from this vendor to get vendor info
        const vendorProduct = products.find(p => 
          p.vendor?._id === vendorId || p.vendor === vendorId || p.vendorId === vendorId
        );
        
        if (!vendorProduct) {
          return {
            _id: vendorId,
            name: "Vendor Store",
            rating: 4.5,
            totalProducts: 0,
            totalOrders: 0,
            joinDate: "2024-01-01",
            description: "Premium quality products",
            location: "India",
            phone: "+91 9876543210",
            verified: true,
            category: "General Store"
          };
        }
        
        return {
          _id: vendorId,
          name: vendorProduct.restaurantName || vendorProduct.vendor?.name || "Vendor Store",
          rating: 4.5,
          totalProducts: products.filter(p => 
            p.vendor?._id === vendorId || p.vendor === vendorId || p.vendorId === vendorId
          ).length,
          totalOrders: 0,
          joinDate: "2024-01-01",
          description: vendorProduct.description || "Premium quality products",
          location: vendorProduct.religion || "India",
          phone: "+91 9876543210",
          verified: true,
          category: vendorProduct.category?.name || "General Store"
        };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching vendor:", error);
      // Return fallback vendor data
      return {
        _id: vendorId,
        name: "Vendor Store",
        rating: 4.5,
        totalProducts: 0,
        totalOrders: 0,
        joinDate: "2024-01-01",
        description: "Premium quality products",
        location: "India",
        phone: "+91 9876543210",
        verified: true,
        category: "General Store"
      };
    }
  },

  // Get products by vendor ID
  async getVendorProducts(vendorId) {
    try {
      // First try to get vendor-specific products
      const token = localStorage.getItem('vendorToken');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      
      const response = await fetch(`${API_BASE}/vendor/products`, { headers });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          // Filter by vendor ID if needed
          const vendorProducts = data.data.filter(p => 
            p.vendor?._id === vendorId || p.vendor === vendorId
          );
          return vendorProducts;
        }
      }
      
      // Fallback to main products API
      const productsResponse = await fetch(`${API_BASE}/products`);
      if (!productsResponse.ok) throw new Error("Failed to fetch products");
      
      const productsData = await productsResponse.json();
      const allProducts = productsData.data || productsData.products || [];
      
      // Filter products by vendor ID
      return allProducts.filter(p => 
        p.vendor?._id === vendorId || p.vendor === vendorId || p.vendorId === vendorId
      );
      
    } catch (error) {
      console.error("Error fetching vendor products:", error);
      return [];
    }
  }
};